// extracted by mini-css-extract-plugin
export default {"container":"CAYQm","innerContainer":"ALVny","title":"XMkCs","body":"iTBnZ","error":"HySSX","button":"qGwjX","isMuted":"y4I7g"};